import { render, staticRenderFns } from "./adminRecord.vue?vue&type=template&id=342fe0ce&scoped=true"
import script from "./adminRecord.js?vue&type=script&lang=js&external"
export * from "./adminRecord.js?vue&type=script&lang=js&external"
import style0 from "./adminRecord.less?vue&type=style&index=0&id=342fe0ce&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342fe0ce",
  null
  
)

export default component.exports